import { getRudderstack } from '@ecomm/shared-window'

export function trackMonitoringAlarmCarouselTabClick(
  carousel_tab_position: number
) {
  getRudderstack(r => {
    r.track('click_monitoring_alarm_carousel', {
      carousel_tab_position
    })
  })
}

export function trackMonitoringCTA() {
  getRudderstack(r => {
    r.track('monitoring_cta')
  })
}

/**
 * Track click compare plans on choose/change and features-alarm-monitoring pages.
 */
export function trackComparePlanClick() {
  getRudderstack(r => {
    r.track('compare_plan_click')
  })
}

/**
 * Called when switching monitoring plans in monitoring components at package pages and bms draft cart
 */
export function trackMonitoringSelectionClick(plan: string) {
  getRudderstack(r => {
    r.track('monitoring_selection_click', { plan })
  })
}

export function trackSwitchPlanType(planType: 'business' | 'home') {
  getRudderstack(r => {
    r.track('switch_plan_type', { planType })
  })
}
